'use client';

import { Sidebar } from '..';
import { usePackStorage } from './usePackStorage';

export function AppLayout({ children }) {
  const { purchasedPacks, selectedPack, purchasedFreePacksCollective, handlePackChange } = usePackStorage();

  return (
    <div className="flex relative bg-[var(--q3-surface-default)] min-h-screen w-full z-50">
      <div className="flex-shrink-0 sm:w-0 lg:w-[100px]">
        <Sidebar
          purchasedPacks={purchasedPacks}
          purchasedFreePacksCollective={purchasedFreePacksCollective}
          selectedPack={selectedPack}
          onPackChange={handlePackChange}
        />
      </div>
      {/* No overflow utility here on purpose. `overflow-x: hidden` alone forces the UA to compute
          overflow-y as `auto` (CSS overflow spec: "if overflow-x or overflow-y is visible and the
          other isn't, the visible one computes to auto") - so there's no way to clip horizontally
          here without also turning this div into a scroll container on the vertical axis. Since
          it has no fixed height (the real page scroll happens on <body>), that scroll-container
          status breaks `position: sticky` on every descendant without ever actually scrolling
          anything itself. min-w-0 on this flex child already does the real work of stopping wide
          content from blowing out the layout; drop this if horizontal overflow reappears and
          handle it per-page instead. */}
      <div className="flex-1 min-w-0 flex justify-center">{children}</div>
    </div>
  );
}
